import { render } from "./CampaignPSC26.vue?vue&type=template&id=60dddf5d"
import script from "./CampaignPSC26.vue?vue&type=script&lang=js"
export * from "./CampaignPSC26.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__